import { render, staticRenderFns } from "./elTitle.vue?vue&type=template&id=b842f760&"
import script from "./elTitle.vue?vue&type=script&lang=js&"
export * from "./elTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports